<div id="usuari-form" ng-cloak>
  <span class="{{ctrl.colorestat}}">{{ctrl.estatusuari}}</span>
      <itec-form
      	name="ctrl.formulari.nom"
      	fields="ctrl.formulari.camps"
      	ng-model="ctrl.usuari"
      	ng-submit-function="ctrl.formulari.func()"
      	errors="ctrl.errors"
        submit-button-text="DEFAULT_GUARDAR"
        backbutton="true"
        backbuttonfunction="ctrl.back()"
        >



         <itec-transclude transclude-to="notificar-registre-button" >
          <div ng-if="ctrl.usuari.deleted==false" >
            <div>
                  <span>{{'USUARI_REGISTRE' | translate}}:</span>
            </div>
            <div ng-if="ctrl.usuari.fictici==false" >
                  <span class="bold">{{'USUARI_REGISTRAT' | translate}}</span>
            </div>
            <div ng-if="ctrl.usuari.fictici==true"  >
                  <span class="bold">{{'USUARI_NO_REGISTRAT' | translate}}</span>
                  <itec-button  label="{{'USUARI_NOTIFICAR_REGISTRE' | translate}}"
                                ng-click-function="ctrl.notificarregistre()">
                  </itec-button >
            </div>
          </div>
        </itec-transclude>


         <itec-transclude transclude-to="notificar-confirmar-button">
         <div ng-if="ctrl.usuari.deleted==false" >
              <div >
                <span>{{'USUARI_CONFIRMACIO' | translate}}:</span>
              </div>
              <div ng-if="ctrl.usuari.confirmat==true"  >
                  <span class="bold">{{'USUARI_CONFIRMAT' | translate}}</span>
              </div>
               <div ng-if="ctrl.usuari.confirmat==false && ctrl.usuari.fictici==true" >
                  <span class="bold">{{'USUARI_NO_CONFIRMAT' | translate}}</span>
              </div>
              <div ng-if="ctrl.usuari.confirmat==false && ctrl.usuari.fictici==false" >
                  <span class="bold">{{'USUARI_NO_CONFIRMAT' | translate}}</span>
                  <itec-button  label="{{'USUARI_NOTIFICAR_CONFIRMAR' | translate}}"
                                ng-click-function="ctrl.notificarconfirmar()">
                  </itec-button >
              </div>
          </div>
        </itec-transclude>

        <itec-transclude  transclude-to="notificar-deleted-button">
           <div ng-if="ctrl.usuari.deleted==true">
                  <span class="bold">{{'USUARI_BAIXA' | translate}}</span>
                  <itec-button  label="{{'USUARI_NOTIFICAR_REGISTRE' | translate}}"
                                ng-click-function="ctrl.notificarregistre()">
                  </itec-button >
           </div>
        </itec-transclude>


      </itec-form>
</div>
